import CookieValue from "./cookie_value";
import LogIf from "./log_if";

export default function fetchResource(url, filters, component) {
  return new Promise((resolve, reject) => {
    console.log("GET ", url);
    if (filters.length > 0) {
      url += "?" + filters;
    }
    try {
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + CookieValue(),
        },
      }).then(
        (res) => {
          console.log(
            "fetch then component.state._isMounted: ",
            component.state._isMounted
          );
          console.log(
            "fetch then component._isMounted: ",
            component._isMounted
          );
          if (component.state._isMounted || component._isMounted) {
            /**component still _isMounted block**/
            if (res.status === 201 || res.status === 200) {
              console.log("mounted response - status:" + res.status);
              console.log("mounted response - statusText:" + res.statusText);
              res.json().then((data) => {
                LogIf("debug", "Got Resource: ");
                LogIf("debug", data);
                console.log("^^^^ fetchResource data: " + JSON.stringify(data));
                component.setState(data);
                resolve();
              });
            } else {
              console.log("rejected mounted response status:" + res.status);
              console.log(
                "rejected mounted response statusText:" + res.statusText
              );
              reject(res.statusText);
            }
          } else {
            console.log("not mounted response:" + res.status);
            console.log("not mounted response:" + res.statusText);
          }
        } /**arrow function**/
      );
    } catch (err) {
      console.log("incatch block");
      if (component.state._isMounted) {
        reject(err);
      }
    }
  });
}
